module.exports = "pegasus/assets/theme2/small/7.jpg";